export enum ValidationScope {
    SinglePeriod,
    MultiplePeriod
}